module.exports = __webpack_public_path__ + "static/list-title-bg5@2x-4e1e6d8bee7d19a894b8d028eda5454e.png";